<!-- src\app\page\invite-page\invite-page.component.html -->
<app-table #invitationTable class="invitation-table" [construct]="construct"></app-table>
